import { c as _c } from "react/compiler-runtime";
import { useAuth } from "../../hooks/use-auth";
import { checkEmailAvailability } from "../../lib/emailAvailability";
import SignUpCard from "./SignUpCard";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SignUpView(t0) {
  const $ = _c(28);
  const {
    authClient,
    trpcClient,
    onSuccess,
    onBackToSignIn,
    onBackToEmail,
    onPrivacyPolicyClick,
    onTermsClick,
    verificationRedirectUrl,
    statusMessage,
    onStatusMessageAction,
    onSignUpComplete,
    signUpCompleteLabel
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    signUp,
    resendVerification,
    isUpdating
  } = useAuth(t1);
  let t2;
  if ($[2] !== trpcClient) {
    t2 = email => checkEmailAvailability(trpcClient, email);
    $[2] = trpcClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleEmailSubmit = t2;
  let t3;
  if ($[4] !== onSuccess || $[5] !== signUp || $[6] !== verificationRedirectUrl) {
    t3 = async formData => {
      const response = await signUp(formData.email, formData.password, formData.firstName, formData.lastName, verificationRedirectUrl);
      if (response.success && onSuccess) {
        onSuccess();
      }
      return response;
    };
    $[4] = onSuccess;
    $[5] = signUp;
    $[6] = verificationRedirectUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSignUp = t3;
  let t4;
  if ($[8] !== resendVerification || $[9] !== verificationRedirectUrl) {
    t4 = email_0 => resendVerification(email_0, verificationRedirectUrl);
    $[8] = resendVerification;
    $[9] = verificationRedirectUrl;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onSignUpComplete) {
    t5 = onSignUpComplete ? {
      onSignUpComplete
    } : {};
    $[11] = onSignUpComplete;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== signUpCompleteLabel) {
    t6 = signUpCompleteLabel ? {
      signUpCompleteLabel
    } : {};
    $[13] = signUpCompleteLabel;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleEmailSubmit || $[16] !== handleSignUp || $[17] !== isUpdating || $[18] !== onBackToEmail || $[19] !== onBackToSignIn || $[20] !== onPrivacyPolicyClick || $[21] !== onStatusMessageAction || $[22] !== onTermsClick || $[23] !== statusMessage || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = /*#__PURE__*/_jsx("div", {
      className: "bg-background sm:flex sm:grow sm:items-start sm:justify-center sm:px-4 lg:px-0",
      children: /*#__PURE__*/_jsx(SignUpCard, {
        onEmailSubmit: handleEmailSubmit,
        onSignUp: handleSignUp,
        onBackToSignIn: onBackToSignIn,
        onBackToEmail: onBackToEmail,
        onPrivacyPolicyClick: onPrivacyPolicyClick,
        onTermsClick: onTermsClick,
        loading: isUpdating,
        statusMessage: statusMessage,
        onStatusMessageAction: onStatusMessageAction,
        onResendVerification: t4,
        ...t5,
        ...t6
      })
    });
    $[15] = handleEmailSubmit;
    $[16] = handleSignUp;
    $[17] = isUpdating;
    $[18] = onBackToEmail;
    $[19] = onBackToSignIn;
    $[20] = onPrivacyPolicyClick;
    $[21] = onStatusMessageAction;
    $[22] = onTermsClick;
    $[23] = statusMessage;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}